export default "assets/images/icons/arrow-white-circle-hover-89a68320.svg";